import { connect } from 'react-redux';
import { combineReducers, createStore } from 'redux';

import nps from './actions/nps';
import submit from './actions/submit';

/**
 * state to props します - 更新を props 経由で行います
 * @param {*} state React.state
 * @return {*} props 変換します
 */
const mapStateToProps = state => state;

/**
 * React.Component を redux `connect` し関連付けます
 * @param {*} component React.Component
 * @return {*} redux `connect` した Component を返します
 */
export const connector = component => connect(mapStateToProps)(component);

/**
 * {@link nps.behavior}, {@link submit.behavior} を `Redux.combineReducers` します
 * @type {Reducer<unknown>}
 */
export const reducer = combineReducers({
  nps: nps.behavior,
  submit: submit.behavior,
});

// ---
export const store = createStore(reducer);

// ---
/**
 * redux store 呼び出すための static class
 */
export class Broadcast {
  /**
   * `redux.store.dispatch` 経由で状態変化を知らせます
   * - change: Nps check action state を伝達します
   * - appear: Nps 出現時に送信する RAT call 状態を伝達します
   * @type {{appear: Broadcast.nps.appear, change: Broadcast.nps.change}}
   */
  static nps = {
    change: (
      payload = { checked: null, name: '', value: null },
      type = nps.type.CHANGE
    ) => {
      store.dispatch({ type, payload: { ...payload } });
    },
    appear: (type = nps.type.APPEAR) => {
      store.dispatch({ type });
    },
  };

  /**
   * `redux.store.dispatch` 経由で状態変化を知らせます
   * - complete: submit 後の完了状態を伝達します
   * - thanks: Thanks 出現時に送信する RAT call 状態を伝達します
   * @type {{thanks: Broadcast.submit.thanks, complete: Broadcast.submit.complete}}
   */
  static submit = {
    complete: (type = submit.type.COMPLETE) => {
      store.dispatch({ type });
    },
    thanks: (type = submit.type.THANKS) => {
      store.dispatch({ type });
    },
    close: (type = submit.type.CLOSE) => {
      store.dispatch({ type });
    },
  };
}

/**
 * redux store initial type 発生させる static class
 */
export class Init {
  /**
   * {@link nps}.type.INITIAL を `redux.store.dispatch` します
   */
  static nps() {
    store.dispatch({ type: nps.type.INITIAL });
  }

  /**
   * {@link submit}.type.INITIAL を `redux.store.dispatch` します
   */
  static submit() {
    store.dispatch({ type: submit.type.INITIAL });
  }
}



// WEBPACK FOOTER //
// ./src/embedded-type/broadcast/index.js